import type { ReactNode } from 'react';
import { useForceLight } from '../lib/theme';

/**
 * Wraps public / client / crew routes so they always render in the warm-paper
 * light theme. Dark is an admin-only option, so brand-facing surfaces never
 * inherit an admin's dark choice.
 */
export default function ForceLight({ children }: { children: ReactNode }) {
  useForceLight();
  return <>{children}</>;
}
